module.exports = __webpack_public_path__ + "static/media/DSC_2902.28b0cedf.jpg";